import { Download } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { DOWNLOAD_NAME, documentUrl } from './document-file';

const LABEL = 'Download our stone catalogue (PDF)';
const TIP = 'Download catalogue (PDF)';

/**
 * The stone catalogue as a download icon in the navbar (D-385), next to the account icon; it replaced the strip above the
 * navbar. Pressing it saves the PDF (`download`, the same file as the menu and the footer card). A small tooltip names it on
 * hover and on keyboard focus (CSS only, `.header-tip`); the accessible name says the same in full.
 */
export function DownloadLink({ className }: { className?: string }) {
  return (
    <span
      className={className === undefined ? 'header-tip' : `header-tip ${className}`}
      data-tip={TIP}
    >
      <Button asChild variant="ghost" round aria-label={LABEL}>
        <a href={documentUrl} download={DOWNLOAD_NAME}>
          <Download size={22} aria-hidden="true" />
        </a>
      </Button>
    </span>
  );
}
